// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// declare const window: any;

// export const environment = {
//   production: true,
//   isConsolelogEnabled:true,

 
//    baseUrl: window.__config?.baseUrl || '',
//   authUrl: window.__config?.authUrl || '',
//   swaggerUrl: window.__config?.swaggerUrl || '',
//   springBase: window.__config?.springBase || '',
//   flaskurl: window.__config?.flaskurl || '',
//   dropdownUrl: window.__config?.dropdownUrl || '',
//   environmentKnowing: window.__config?.environmentKnowing || '',
//   idpUrl: window.__config?.idpUrl || '',
//   isSSOlogin: window.__config?.isSSOlogin || false,
//   vaultOrigins: window.__config?.vaultOrigins || ''

//   //    baseUrl: 'http://localhost:8443/api',
//   //  authUrl: 'http://localhost:8443/auth',
//   //  swaggerUrl: 'http://localhost:8443/swaggerui',
//   //  springBase: 'http://localhost:8443/jraap',
//   //  flaskurl:'http://13.201.136.161:8443',
//   // // This is dropdown of screencreator.
//   //  dropdownUrl: 'http://localhost:8443',
//   //  environmentKnowing: 'UAT',
//   //  idpUrl:'https://pingfed-ut.merck.com/idp/startSSO.ping?PartnerSpId=pvdmt&ACSIdx=1',
//   //  isSSOlogin:false,
//   //  vaultOrigins:'https://partnersi-jeevlifeworks-safety.veevavault.com'
// };

// Modified by DARSHAN NAGARAJ
// Date:11-03-2026
// Modified the implementation for Externalize Angular API Endpoints for Runtime Configuration

declare const window: any;

export const environment = {
  production: true,
  isConsolelogEnabled: true,

  get baseUrl() {
    return window.__config?.baseUrl || '';
  },

  get authUrl() {
    return window.__config?.authUrl || '';
  },

  get swaggerUrl() {
    return window.__config?.swaggerUrl || '';
  },

  get springBase() {
    return window.__config?.springBase || '';
  },

  get flaskurl() {
    return window.__config?.flaskurl || '';
  },

  get dropdownUrl() {
    return window.__config?.dropdownUrl || '';
  },

  get environmentKnowing() {
    return window.__config?.environmentKnowing || '';
  },

  get idpUrl() {
    return window.__config?.idpUrl || '';
  },

  get isSSOlogin() {
    return window.__config?.isSSOlogin || false;
  },

  get vaultOrigins() {
    return window.__config?.vaultOrigins || '';
  },
   get oneSignalAppId() {
    return window.__config?.oneSignalAppId || '';
  },
   get jaivikUrl() {
    return window.__config?.jaivikUrl || '';
  }
};
console.log("Environment Loaded:", environment);

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

// onesignal App IDS:
  // Test : c5fc7525-c001-4a41-bfd0-021b55a5ab0b
  // Temp Test: 6fc66f2a-92c3-47bb-b678-f3dca6778bf8
  // Temp Linux: 955a7aa9-8444-4dc3-9e00-e98154fd348b